import { Card, Image } from '@wework/dieter-ui'
import { Icon } from 'semantic-ui-react'
import {
  CarouselProvider,
  Slider,
  Slide,
  ButtonBack,
  ButtonNext,
} from 'pure-react-carousel'
import React from 'react'

import 'pure-react-carousel/dist/react-carousel.es.css'
import { LeftArrow, RightArrow } from '../Icons'

const YesObstructions =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/YesObstructions.png'
const NoObstructions =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/NoObstructions.png'
const NWV =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/NWV.png'
const NWNV =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/NWNV.png'
const WAA =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/WAA.png'
const WA =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/WA.png'
const WBA =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/WBA.png'

const Average =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/Average.png'
const AA =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/AA.png'
const BA =
  'https://wek8s-phoenix-lbe-occupancy-map-assets.s3.amazonaws.com/IMAssets/BA.png'

export default function ExampleCard({ value, type = 'LIGHT' }) {
  const obstructionValues = {
    TRUE: {
      image: YesObstructions,
      header: 'Obstruction - Yes',
      text:
        'An Obstruction is any sizeable object that limits the usage of space (e.g. columns). ',
    },
    FALSE: {
      image: NoObstructions,
      header: 'Obstruction - No',
      text: 'Office without any visible obstruction.',
    },
  }

  const viewValues = {
    NO_WINDOW_VIEW: {
      image: NWV,
      header: 'View quality – view without window',
      text:
        'Office with a view but no external window. E.g. middle office with partial / obstructed outside view.',
    },
    NO_WINDOW_NO_VIEW: {
      image: NWNV,
      header: 'View quality – no View',
      text: 'Office without any external window and any visible outside view.',
    },
    // UNKNOWN_VIEW: {
    //   image: null,
    //   header: 'Unknown VIEW',
    //   text: 'Unknown View.',
    // },
    WINDOW_ABOVE_AVERAGE_VIEW: {
      image: WAA,
      header: 'View quality – above average',
      text:
        'Above average view for the building. E.g. a non-obstructed, exceptional city/scenic view.',
    },
    WINDOW_AVERAGE_VIEW: {
      image: WA,
      header: 'View quality – average',
      text:
        'Average view for the building. E.g. partially obstructed, facing or overlooking other nearby buildings.',
    },
    WINDOW_BELOW_AVERAGE_VIEW: {
      image: WBA,
      header: 'View quality – below average',
      text:
        'Below average view for the building. E.g. obstructed view, directly facing a wall.',
    },
  }

  const lightValues = {
    // UNKNOWN_LIGHT: {
    //   image: null,
    //   header: 'Unknown VIEW',
    //   text: 'Unknown View.',
    // },
    ABOVE_AVERAGE_LIGHT: {
      image: AA,
      header: 'Natural light quality – above average',
      text: 'Office with exceptional lighting.',
    },
    AVERAGE_LIGHT: {
      image: Average,
      header: 'Natural light quality – average',
      text: 'Standard WeWork office. Around average for building.',
    },
    BELOW_AVERAGE_LIGHT: {
      image: BA,
      header: 'Natural light quality – below average',
      text:
        'No natural light. Interior office that is very dark and closed off.',
    },
  }

  const getValues = () => {
    switch (type) {
      case 'OBSTRUCTIONS':
        return obstructionValues
      case 'LIGHT':
        return lightValues
      case 'VIEW':
        return viewValues
      default:
        return obstructionValues
    }
  }

  return (
    <CarouselProvider
      naturalSlideWidth={310}
      naturalSlideHeight={290}
      totalSlides={Object.entries(getValues()).length}
    >
      <Slider>
        {Object.entries(getValues()).map((entry, index) => {
          return (
            <Slide index={index}>
              <Card style={{ width: '100%', height: '100%' }} key={index}>
                <Image src={entry[1].image} />
                <Card.Content>
                  <Card.Header>{entry[1].header}</Card.Header>
                  <Card.Description>{entry[1].text}</Card.Description>
                </Card.Content>
              </Card>
            </Slide>
          )
        })}
      </Slider>
      <div
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translate(-50%, 0)',
          top: '50%',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '8px',

          width: '100%',
        }}
      >
        <ButtonBack
          style={{
            backgroundColor: '#fff',
            border: '1px solid #E6E6E6',
            borderRadius: 40,
            height: 28,
            color: 'black',
            width: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <LeftArrow width={12} height={12} />
        </ButtonBack>
        <ButtonNext
          style={{
            backgroundColor: '#fff',
            border: '1px solid #E6E6E6',
            borderRadius: 40,
            height: 28,
            color: 'black',
            width: 28,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <RightArrow width={12} height={12} />
        </ButtonNext>
      </div>
    </CarouselProvider>
  )
}
